(function () {
  'use strict';

  var IS_EDITOR = !!(window.Shopify && window.Shopify.designMode);

  // Selectors for elements that must NOT trigger the whole-slide link
  var INTERACTIVE = '.nova-btn, .nova-dot-btn, .nova-nav-btn, a, button, [role="button"]';

  function bindSlideLinks(wrap) {
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('.nova-slide[data-slide-link]'));

    slides.forEach(function (slide) {
      if (slide.dataset.novaLinkBound === '1') return;
      slide.dataset.novaLinkBound = '1';

      var url = slide.getAttribute('data-slide-link');
      var target = slide.getAttribute('data-slide-link-target');
      if (!url) return;

      slide.addEventListener('click', function (e) {
        // In the theme editor, never navigate — merchants need to select blocks
        if (IS_EDITOR) {
          if (e.target.closest('.nova-slide-link')) e.preventDefault();
          return;
        }

        // Ignore modified clicks so ctrl/cmd/middle-click still work natively
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

        var interactive = e.target.closest(INTERACTIVE);

        // The overlay anchor itself handles navigation natively — let it through
        if (interactive && interactive.classList.contains('nova-slide-link')) return;

        // Any other real link/button (Button 1, Button 2, dots, arrows) wins
        if (interactive) return;

        // Fallback: something is stacked above the overlay, so navigate manually
        e.preventDefault();
        if (target === '_blank') {
          window.open(url, '_blank', 'noopener');
        } else {
          window.location.href = url;
        }
      });
    });
  }

  function initSlideshow(wrap) {
    if (!wrap) return;

    // Slide links are bound even for single-slide sections
    bindSlideLinks(wrap);

    if (wrap.dataset.novaInit === '1') return;
    wrap.dataset.novaInit = '1';

    var track = wrap.querySelector('.nova-slideshow');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.nova-slide'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(wrap.querySelectorAll('.nova-dot-btn'));
    var prevBtn = wrap.querySelector('.nova-nav-btn[data-direction="prev"]');
    var nextBtn = wrap.querySelector('.nova-nav-btn[data-direction="next"]');

    var autoplayEnabled = wrap.dataset.autoplay === 'true';
    var speed = parseInt(wrap.dataset.autoplaySpeed, 10);
    if (isNaN(speed) || speed < 1000) speed = 5000;

    var current = 0;
    var timerId = null;
    var isPaused = false;
    var isHidden = (typeof document.hidden === 'boolean') ? document.hidden : false;

    function clearTimer() {
      if (timerId !== null) {
        clearTimeout(timerId);
        timerId = null;
      }
    }

    function scheduleNext() {
      clearTimer();
      if (!autoplayEnabled || isPaused || isHidden) return;
      timerId = setTimeout(function () {
        try {
          goTo(current + 1);
        } catch (e) {
          // Never let an exception kill the autoplay chain — reschedule anyway
          scheduleNext();
        }
      }, speed);
    }

    function goTo(index) {
      if (!slides.length) return;
      // Normalise index (handles wrap-around in both directions)
      var next = ((index % slides.length) + slides.length) % slides.length;

      for (var i = 0; i < slides.length; i++) {
        if (i === next) {
          slides[i].classList.add('is-active');
        } else {
          slides[i].classList.remove('is-active');
        }
      }
      for (var j = 0; j < dots.length; j++) {
        if (j === next) {
          dots[j].classList.add('is-active');
        } else {
          dots[j].classList.remove('is-active');
        }
      }
      current = next;
      scheduleNext();
    }

    // Dot navigation
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    // Pause on hover (desktop)
    wrap.addEventListener('mouseenter', function () {
      isPaused = true;
      clearTimer();
    });
    wrap.addEventListener('mouseleave', function () {
      isPaused = false;
      scheduleNext();
    });

    // Touch handling (mobile) — pause briefly on touch, resume on touch end/cancel
    wrap.addEventListener('touchstart', function () {
      isPaused = true;
      clearTimer();
    }, { passive: true });
    wrap.addEventListener('touchend', function () {
      isPaused = false;
      scheduleNext();
    }, { passive: true });
    wrap.addEventListener('touchcancel', function () {
      isPaused = false;
      scheduleNext();
    }, { passive: true });

    // Page Visibility — pause when tab is hidden, resume when visible again
    document.addEventListener('visibilitychange', function () {
      isHidden = document.hidden;
      if (isHidden) {
        clearTimer();
      } else {
        scheduleNext();
      }
    });

    // Window focus/blur as a fallback (some mobile browsers fire these reliably when visibilitychange does not)
    window.addEventListener('blur', function () {
      isHidden = true;
      clearTimer();
    });
    window.addEventListener('focus', function () {
      isHidden = false;
      scheduleNext();
    });

    // Safety net: if for any reason the timer is lost, a heartbeat re-arms it.
    // Runs every (speed + 2000)ms; only re-arms when conditions are right and no timer is active.
    setInterval(function () {
      if (autoplayEnabled && !isPaused && !isHidden && timerId === null) {
        scheduleNext();
      }
    }, speed + 2000);

    // Kick off
    scheduleNext();

    // Shopify theme editor support
    if (IS_EDITOR) {
      var sectionEl = wrap.closest('.nova-section');
      if (sectionEl) {
        document.addEventListener('shopify:block:select', function (e) {
          if (sectionEl.contains(e.target)) {
            var idx = parseInt(e.target.dataset.slideIndex, 10);
            if (!isNaN(idx)) {
              isPaused = true;
              clearTimer();
              goTo(idx);
            }
          }
        });
        document.addEventListener('shopify:block:deselect', function (e) {
          if (sectionEl.contains(e.target)) {
            isPaused = false;
            scheduleNext();
          }
        });
      }
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = scope.querySelectorAll('.nova-slideshow-wrap');
    for (var i = 0; i < wraps.length; i++) {
      initSlideshow(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init when a section loads in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    // Reset init flags so re-loaded sections get re-bound
    var wraps = e.target.querySelectorAll('.nova-slideshow-wrap');
    for (var i = 0; i < wraps.length; i++) {
      wraps[i].dataset.novaInit = '';
      var slides = wraps[i].querySelectorAll('.nova-slide');
      for (var j = 0; j < slides.length; j++) {
        slides[j].dataset.novaLinkBound = '';
      }
    }
  });
})();